import React, { useState } from 'react';
import { useEffect } from 'react';
import { getInbox } from '../../services/material-services';
import { useAuth } from '../../hooks/useAuth';
import PaginationControlled from '../materials/mat-pagination';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import MarkEmailUnreadIcon from '@mui/icons-material/MarkEmailUnread';
import CallReceivedIcon from '@mui/icons-material/CallReceived';
import ForwardIcon from '@mui/icons-material/Forward';
import { Avatar, Divider, Grid, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import DialogAnswer from '../layout/dialog/dialog-answer';



function InboxMessageDetail() {
    const { authData } = useAuth()
    const [isAdmin, setIsAdmin] = useState(false)

    const [open, setOpen] = useState(false)
    const [myInbox, setMyInbox] = useState(null)
    // const [error, setError] = useState(false)
    const [loading, setLoding] = useState(false)
    const [page, setPage] = useState(1)
    const [totalPage, setTotalPage] = useState(1)
    const [showPagin, setShowPagin] = useState(false)    // const [summary, setSummary] = useState(0)
    const numRows = 10
    const countShow = 10
    const searchFact = ''

    useEffect(()=>{
        if(authData?.user){
            setIsAdmin(authData.user?.profile?.is_permium)
        }
        setLoding(true)
        const getData = async() =>{
            await getInbox(authData?.token, page, countShow, searchFact)
            .then(data => {
                setMyInbox(data)
                // console.log("getInbox", data)

                const totalPTranc = Math.trunc(data.count / numRows)
                const totalP = data.count / numRows
                // console.log(data)
                // console.log(numRows, totalP, totalPTranc, data.count)
                
                setTotalPage(totalPTranc)
                if(totalPTranc < totalP & totalP > 1){
                  setTotalPage(totalPTranc + 1)
                  setShowPagin(true)
                }
                
                if(totalPage > 1){
                  setShowPagin(true)
                }

                setLoding(false)
            }).catch( e => {
                // setError(true)
                setLoding(false)
            })
        }
        getData()
    }, [])
    
    const handleRefresh = (value) => {
      // console.log(value)
        setPage(value)
        setLoding(true)
        const getData = async() =>{
            await getInbox(authData?.token, page, countShow, searchFact)
            .then(data => {
                setMyInbox(data)
                

                const totalPTranc = Math.trunc(data.count / numRows)
                const totalP = data.count / numRows
                // console.log(data)
                // console.log(numRows, totalP, totalPTranc, data.count)
                
                setTotalPage(totalPTranc)
                if(totalPTranc < totalP){
                  setTotalPage(totalPTranc + 1)
                  setShowPagin(true)
                }
                
                if(totalPage > 1){
                  setShowPagin(true)
                }

                setLoding(false)
            }).catch( e => {
                // setError(true)
                setLoding(false)
            })
        }
        getData()
    }

    const handleClickOpen = () => {
        setOpen(true)
    }
  
    const handleClose = (value) => {
        setOpen(false)
        // setSelectedValue(value)
    }


  return (
    <React.Fragment>
      <List sx={{ width: '100%', maxWidth: 800, bgcolor: 'background.paper' }}>
          {myInbox?.results && myInbox.results?.map(row => (
              <div key={row.id}>
                  <Grid container spacing={1} justifyContent="center">
                      <Grid item xs={8}>
                        <ListItem key={row.id} alignItems="flex-start">
                          <ListItemAvatar>
                              <Avatar alt={row.title}  />
                          </ListItemAvatar>
                          <ListItemText
                            primary={
                              <Typography 
                                  component="span"
                                  variant="p"
                                  color="textPrimary"
                                  >
                                  {row.title}
                              </Typography>
                            }
                          />
                        </ListItem>
                    </Grid>
                    {isAdmin &&
                        <Grid item xs={2}>
                            <ListItemButton 
                                sx={{textAlign: 'center'}}
                                onClick={handleClickOpen}
                              >
                              <Link to='' >
                                  جواب
                              </Link>
                            </ListItemButton>
                            <DialogAnswer selectedValue={row} open={open} onClose={handleClose}/>
                        </Grid>
                    }
                </Grid>
                <ListItem alignItems="flex-start">
                    <ListItemText primary={
                        <>
                          <Typography
                              component="span"
                              variant="p"
                              color="textPrimary"
                            >
                            {row.remarks}
                          </Typography>
                          <br/>
                          <div style={{textAlign: 'left'}}>
                              {row.req_status ? <CallReceivedIcon/> : <ForwardIcon />}
                              {!row.status_read ? <MarkEmailUnreadIcon/> : <MailOutlineIcon />}
                          </div>
                        </>
                    }
                    />
                </ListItem>
                
                <Divider />
              </div>
          ))}
        </List>    
        
        {showPagin &&
            <div style={{width: '100%', display: 'block', textAlign: 'center'}}>
                <PaginationControlled onChange={handleRefresh} pageNow={page} totalCount={totalPage}/>
            </div>
        }            
      </React.Fragment>
  )
}

export default InboxMessageDetail
